import httpClient from '@/services/http/httpClient'

export const apiPostAdditionalInfo = params => {
  return httpClient
    .post('fnol/additionalInfo', params)
    .then(data => data)
    .catch(error => Promise.reject(error))
}
